import { createContext, useContext, useState, useEffect } from "react";

const CommonContext = createContext()

export const useCommonContext = () => {
  return useContext(CommonContext)
}

export const CommonContextProvider = ({ children }) => {
  const [sidebarWidth, setSidebarWidth] = useState('250px'); // default 250px
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
    setSidebarWidth((prev) => (prev === "250px" ? "60px" : "250px"));
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 700) {
        setSidebarWidth('80px');
        setIsSidebarCollapsed(true)
      }
    };

    handleResize(); // Call once on mount
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const value = { sidebarWidth, setSidebarWidth, toggleSidebar, isSidebarCollapsed };

  return <CommonContext.Provider value={value}>{children}</CommonContext.Provider>
}